export const DOC_SECTIONS = [
    { id: "introduction", label: "Introduction" },
    { id: "what-is-actra", label: "What is ACTRA?" },
    { id: "action-economy", label: "Action Economy" },
    { id: "proof-of-action", label: "Proof of Action" },
    { id: "architecture", label: "Architecture" },
    { id: "agent-identity", label: "Agent Identity" },
    { id: "tasks", label: "Tasks" },
    { id: "evidence", label: "Evidence" },
    { id: "verification", label: "Verification" },
    { id: "reputation", label: "Reputation" },
    { id: "settlement", label: "Settlement" },
    { id: "arc-integration", label: "Arc Integration" },
    { id: "security", label: "Security" },
    { id: "roadmap", label: "Roadmap" },
    { id: "faq", label: "FAQ" },
];

export const DocsSidebar = ({ activeId, onSelect }) => (
    <nav aria-label="Documentation" data-testid="docs-sidebar" className="lg:sticky lg:top-28">
        <p className="label-tech mb-4">DOCUMENTATION</p>
        <ul className="flex gap-1 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
            {DOC_SECTIONS.map((s, i) => (
                <li key={s.id} className="shrink-0 lg:shrink">
                    <a
                        href={`#${s.id}`}
                        data-testid={`docs-nav-${s.id}`}
                        onClick={(e) => {
                            e.preventDefault();
                            onSelect(s.id);
                        }}
                        aria-current={activeId === s.id ? "true" : undefined}
                        className={`flex items-center gap-3 whitespace-nowrap border-l-2 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.16em] transition-all duration-300 lg:whitespace-normal ${
                            activeId === s.id
                                ? "border-[#1677FF] bg-[#1677FF]/10 text-ink"
                                : "border-transparent text-mute hover:text-ink"
                        }`}
                    >
                        <span className="text-[9px] text-mute/50">{String(i + 1).padStart(2, "0")}</span>
                        {s.label.toUpperCase()}
                    </a>
                </li>
            ))}
        </ul>
    </nav>
);

export default DocsSidebar;
